<template>
  <div>
    <h3>{{ $t("navigation." + ROUTE_REGISTER) }}</h3>
    <UserForm @userSubmitted="login" :isNew="true" />
  </div>
</template>

<script>
import UserForm from "./UserForm";
import { ROUTE_REGISTER } from "./../../constants";

export default {
  name: "Register",
  components: { UserForm },
  data() {
    return {
      ROUTE_REGISTER
    };
  },
  computed: {
    validForm() {
      return true;
    }
  },
  methods: {
    login(user) {
      // LOGIN TEST
      this.$store.dispatch("register", {
        email: user.email,
        password: user.password,
        pantryId: user.pantryId
      });
    }
  }
};
</script>

<style lang="scss"></style>
